import { render, staticRenderFns } from "./CreateIncidentModal.vue?vue&type=template&id=f8e08a60&scoped=true"
import script from "./CreateIncidentModal.vue?vue&type=script&lang=js"
export * from "./CreateIncidentModal.vue?vue&type=script&lang=js"
import style0 from "./CreateIncidentModal.vue?vue&type=style&index=0&id=f8e08a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e08a60",
  null
  
)

export default component.exports